/*
  CANIPANI — chercheur de taille.
  Le poids saisi est comparé aux tranches du guide des tailles : ce sont les
  mêmes seuils que ceux affichés sur les cartes, il n'y a pas de barème caché.
  Aucune dépendance, aucun appel réseau.
*/
(function () {
  'use strict';

  function euros(v) { return v || ''; }

  function carte(p) {
    var img = p.image
      ? '<img src="' + p.image + '" alt="" width="120" height="120" loading="lazy">'
      : '<span class="finder__vignette-vide" aria-hidden="true"></span>';
    return (
      '<a class="finder__produit" href="' + p.url + '">' +
      '<span class="finder__vignette">' + img + '</span>' +
      '<span class="finder__produit-texte">' +
      '<span class="finder__produit-nom">' + p.title + '</span>' +
      '<span class="finder__produit-prix">' + euros(p.price) + '</span>' +
      '</span></a>'
    );
  }

  function rendre(zone, tranche, poids) {
    if (!tranche) { zone.innerHTML = ''; return; }

    var dims = '<span class="finder__dim">' + tranche.dimensions + '</span>';
    if (tranche.inner) {
      dims += '<span class="finder__dim finder__dim--inner">Couchage ' + tranche.inner + '</span>';
    }

    var produits = '';
    if (tranche.products && tranche.products.length) {
      produits = '<div class="finder__produits">' + tranche.products.map(carte).join('') + '</div>';
    }

    var lien = tranche.link
      ? '<a class="btn btn--primary btn--small" href="' + tranche.link + '">Voir les paniers en ' + tranche.label + '</a>'
      : '';

    zone.innerHTML =
      '<div class="finder__reponse">' +
      '<p class="finder__phrase">Pour un chien de <strong>' + poids + ' kg</strong>, ' +
      'la taille <strong>' + tranche.label + '</strong>.</p>' +
      '<div class="finder__dims">' + dims + '</div>' +
      produits + lien +
      '<p class="finder__rappel">Le poids n\'est qu\'un repère. Mesurez votre chien couché sur le ' +
      'flanc, de la truffe à la base de la queue, puis ajoutez 15 à 20 cm — c\'est la mesure qui tranche.</p>' +
      '</div>';
  }

  function choisir(tranches, poids) {
    for (var i = 0; i < tranches.length; i++) {
      var max = tranches[i].max;
      var ouverte = !max || max <= 0 || max >= 900;
      if (ouverte || poids <= max) return tranches[i];
    }
    return tranches[tranches.length - 1];
  }

  function init(bloc) {
    if (bloc.dataset.finderPret === '1') return;
    var modele = bloc.parentNode.querySelector('[data-finder-data]');
    if (!modele) return;

    var tranches;
    try {
      tranches = JSON.parse(modele.innerHTML.trim());
    } catch (e) { return; }
    if (!tranches || !tranches.length) return;

    // sans seuil de poids renseigné, le chercheur ne peut rien affirmer :
    // mieux vaut ne rien afficher qu'une taille prise au hasard.
    var exploitable = tranches.filter(function (t) { return t.max && t.max > 0 && t.max < 900; });
    if (!exploitable.length) { bloc.hidden = true; return; }

    // les tranches sans maximum passent en dernier : c'est la catégorie ouverte
    tranches.sort(function (a, b) {
      var ma = a.max && a.max > 0 ? a.max : Infinity;
      var mb = b.max && b.max > 0 ? b.max : Infinity;
      return ma - mb;
    });

    var champ = bloc.querySelector('[data-finder-range]');
    var valeur = bloc.querySelector('[data-finder-value]');
    var zone = bloc.querySelector('[data-finder-result]');
    if (!champ || !zone) return;

    function maj() {
      var poids = parseInt(champ.value, 10) || 1;
      if (valeur) valeur.textContent = poids + ' kg';
      champ.setAttribute('aria-valuetext', poids + ' kilogrammes');
      rendre(zone, choisir(tranches, poids), poids);
    }

    champ.addEventListener('input', maj);
    champ.addEventListener('change', maj);
    maj();
    bloc.dataset.finderPret = '1';
  }

  function tout() {
    document.querySelectorAll('[data-finder]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tout);
  } else {
    tout();
  }
  // l'éditeur de thème recharge les sections sans recharger la page
  document.addEventListener('shopify:section:load', tout);
})();
